import {
  GetTicketInteractionsSuccess,
  PostTicketInteractionsSuccess,
  PostTicketInteractionsError,
  TicketActionTypes
} from '../../actions/ticket/ticket.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { TicketService } from '../../services/ticket/ticket.service';
import { Injectable } from '@angular/core';
import { switchMap, map, mergeMap, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { IFileRelation } from 'src/app/shared/models/file/IFileRelation';
import { FileRelation } from 'src/app/shared/models/file/FileRelation';
import { IFile } from 'src/app/shared/models/file/IFile';
import { UserService } from '../../services/user/user.service';
import { GenerateInteractionItemGuid } from 'src/app/shared/models/interaction/IInteraction';

@Injectable()
export class TicketInteractionEffects {
  @Effect()
  public getTicketInteractions() {
    return this.actions.pipe(
      ofType(TicketActionTypes.GET_TICKET_INTERACTIONS),
      switchMap((action: any) => {
        const body = {
          application: 'DirectMessaging',
          method: 'searchMessages',
          parameters: {
            filter: [
              {
                field: 'creation_time',
                operator: 'within',
                value: 'yearLast'
              },
              {
                field: 'topic_id',
                operator: 'equals',
                value: action.ticketId
              }
            ],
            paging: action.paging
          }
        };
        return this.ticketService.post(body).pipe(
          map((interactions: any) => {
            return GetTicketInteractionsSuccess({
              interactions: interactions.results.map(interaction => {
                return {
                  ...interaction,
                  incomingFiles: this.getFilesFromInteraction(interaction)
                };
              }),
              totalCount: interactions.totalcount
            });
          })
        );
      })
    );
  }

  @Effect()
  public postTicketInteraction() {
    return this.actions.pipe(
      ofType(TicketActionTypes.POST_TICKET_INTERACTION),
      mergeMap((action: any) => {
        return this.userService
          .getAccountInfo()
          .pipe(switchMap((accountInfo) => {
            const attachments: IFileRelation[] = (action.files || []).map(
              (file: IFile) => {
                return {
                  id: file.result.id,
                  name: file.result.name,
                  size: file.result.size,
                  tempFile: file.result
                }
              }
            );

            const interactionId = GenerateInteractionItemGuid(40);

            const body = {
              application: 'DirectMessaging',
              method: 'saveMessage',
              parameters: {
                recordData: {
                  id: interactionId,
                  customer_id: accountInfo.contactId,
                  customer_name: accountInfo.accountDisplayName,
                  customfields: {},
                  source: accountInfo.accountDisplayName,
                  dest: '',
                  document_type: 1,
                  max_try: 1,
                  message: action.interaction.message,
                  priority: 20,
                  skill_group_id: 1,
                  folder_id: '1',
                  status: '1',
                  public: '1',
                  title: action.interaction.title,
                  topic_id: action.interaction.topic_id,
                  relations: [{
                    own_model: 'DirectMessaging_Model_Message',
                    own_backend: 'Sql',
                    own_id: interactionId,
                    own_degree: 'sibling',
                    related_model: 'CPM_Model_Topic',
                    related_backend: 'Sql',
                    related_id: action.interaction.topic_id,
                    type: 'TOPIC_REL'
                  }, {
                    own_model: 'DirectMessaging_Model_Message',
                    own_backend: 'Sql',
                    own_id: interactionId,
                    own_degree: 'sibling',
                    related_model: 'Addressbook_Model_Contact',
                    related_backend: 'Sql',
                    related_id: accountInfo.contactId,
                    type: 'TOPIC_REL'
                  }],
                  attachments
                },
                externalRequest: true
              }
            };

            return this.ticketService.post(body).pipe(
              map((interaction: any) => {
                return PostTicketInteractionsSuccess({
                  ...interaction,
                  incomingFiles: this.getFilesFromInteraction(interaction)
                });
              }),
              catchError((error: any) => {
                return of(PostTicketInteractionsError({ error }));
              })
            );
          }));
      })
    );
  }

  private getFilesFromInteraction(interaction: any) {
    return interaction.relations
      .filter(relation => relation.type === 'FILE')
      .map(relation => ({
        ...relation.related_record,
        related_id: relation.related_id
      }));
  }

  constructor(
    private actions: Actions,
     private ticketService: TicketService,
     private userService: UserService) { }
}
